var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 185,
    viewBox: "0 0 276 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.636 108.305c1.086 20.012-38.039 60.704-86.263 45.642-22.428-7.005-20.529-18.633-37.583-33.957-10.166-9.133-24.772-16.04-28.834-29.316-3.51-11.46-1.357-23.776 4.727-31.788 13.683-18.017 41.306-30.355 68.524-1.967 27.218 28.388 76.622-.226 79.429 51.386z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.911 64.193c-3.805 6.792-12.14 7.725-25.493 6.434-10.042-.972-19.199-1.725-29.242-7.2-7.03-3.83-12.594-9.011-16.655-14.044-4.401-5.452-10.543-11.674-7.532-17.856 4.138-8.491 28.069-15.643 51.307-3.947 25.526 12.85 31.338 29.975 27.615 36.613z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.048 147.258c-8.866-12.404-17.945-25.586-29.832-32.079-12.262-6.7-14.523-2.571-15.372 3.995-.849 6.565 2.934 22.121 19.668 30.971 16.737 8.854 33.832 8.721 25.536-2.887z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.424 25.033h-90.81a6.133 6.133 0 0 0-6.134 6.133V58.43a6.133 6.133 0 0 0 6.133 6.134h90.811a6.133 6.133 0 0 0 6.133-6.134V31.166a6.133 6.133 0 0 0-6.133-6.133z",
    fill: "#fff",
    stroke: "#C0C9D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.633 37.173h-58.198a2.32 2.32 0 1 0 0 4.642h58.198a2.32 2.32 0 1 0 0-4.642zM154.496 47.527h-36.061a2.32 2.32 0 1 0 0 4.642h36.061a2.32 2.32 0 1 0 0-4.642z",
    fill: "#C0C9D5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.816 54.763c-5.464 0-9.894-4.492-9.894-10.033 0-5.54 4.43-10.033 9.894-10.033s9.894 4.492 9.894 10.033c0 5.54-4.43 10.033-9.894 10.033z",
    fill: "#0065FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.62 41.773c.24.24.24.628 0 .867l-4.906 4.907a.614.614 0 0 1-.868-.867l4.907-4.907a.613.613 0 0 1 .867 0z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.846 41.773c.24-.24.628-.24.868 0l4.906 4.907a.612.612 0 1 1-.867.867l-4.907-4.907a.613.613 0 0 1 0-.867z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.424 72.657h-90.81a6.133 6.133 0 0 0-6.134 6.134v27.263a6.133 6.133 0 0 0 6.133 6.133h90.811a6.133 6.133 0 0 0 6.133-6.133V78.791a6.133 6.133 0 0 0-6.133-6.134z",
    fill: "#fff",
    stroke: "#C0C9D5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M176.633 84.797h-58.198a2.32 2.32 0 1 0 0 4.642h58.198a2.32 2.32 0 1 0 0-4.642zM154.496 95.151h-36.061a2.32 2.32 0 1 0 0 4.642h36.061a2.32 2.32 0 1 0 0-4.642z",
    fill: "#C0C9D5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.816 102.387c-5.464 0-9.894-4.492-9.894-10.033 0-5.54 4.43-10.033 9.894-10.033s9.894 4.492 9.894 10.033c0 5.54-4.43 10.033-9.894 10.033z",
    fill: "#0065FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.62 89.773c.24.24.24.628 0 .867l-4.906 4.907a.614.614 0 0 1-.868-.867l4.907-4.907a.613.613 0 0 1 .867 0z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.846 89.773c.24-.24.628-.24.868 0l4.906 4.907a.612.612 0 1 1-.867.867l-4.907-4.907a.613.613 0 0 1 0-.867z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M183.424 120.282h-90.81a6.133 6.133 0 0 0-6.134 6.133v27.263a6.133 6.133 0 0 0 6.133 6.133h90.811a6.133 6.133 0 0 0 6.133-6.133v-27.263a6.133 6.133 0 0 0-6.133-6.133z",
    fill: "#fff",
    stroke: "#C0C9D5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M176.633 132.421h-58.198a2.32 2.32 0 1 0 0 4.642h58.198a2.32 2.32 0 1 0 0-4.642zM154.496 142.775h-36.061a2.32 2.32 0 1 0 0 4.642h36.061a2.32 2.32 0 1 0 0-4.642z",
    fill: "#C0C9D5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.816 150.011c-5.464 0-9.894-4.492-9.894-10.033 0-5.54 4.43-10.033 9.894-10.033s9.894 4.493 9.894 10.033c0 5.541-4.43 10.033-9.894 10.033z",
    fill: "#0065FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.62 136.773c.24.239.24.628 0 .867l-4.906 4.907a.613.613 0 1 1-.868-.867l4.907-4.907a.612.612 0 0 1 .867 0z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.846 136.773c.24-.24.628-.24.868 0l4.906 4.907a.612.612 0 1 1-.867.867l-4.907-4.907a.613.613 0 0 1 0-.867z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M197.424 54.848a1.065 1.065 0 1 0 2.058.551 1.065 1.065 0 0 0-2.058-.55z",
    fill: "#E7E9ED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M203.579 75.336a1.63 1.63 0 1 0 0-3.261 1.63 1.63 0 0 0 0 3.261zM74.337 127.212a2.447 2.447 0 1 0 0 4.894 2.447 2.447 0 0 0 0-4.894zM68.683 77.671a1.716 1.716 0 1 1 0-3.431 1.716 1.716 0 0 1 0 3.431z",
    fill: "#009DFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.091 108.293a3.099 3.099 0 1 1 0-6.197 3.099 3.099 0 0 1 0 6.197z",
    fill: "#E1E4E5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M206.771 130.148a3.098 3.098 0 1 1-.002-6.196 3.098 3.098 0 0 1 .002 6.196zM75.54 93.18a1.524 1.524 0 1 1-2.945.79 1.524 1.524 0 0 1 2.945-.79zM198.204 95.74a1.524 1.524 0 1 1-2.943.789 1.524 1.524 0 0 1 2.943-.79zM75.859 61.136a2.028 2.028 0 1 1 0-4.055 2.028 2.028 0 0 1 0 4.055z",
    fill: "#E7E9ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 167.874,
    y1: 228.26,
    x2: 94.688,
    y2: -101.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 178.274,
    y1: 108.21,
    x2: 144.354,
    y2: -44.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 97.149,
    y1: 187.974,
    x2: 68.061,
    y2: 53.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/no-data-found.57a90bde14f44e84372f00a8608caff3.svg";
export { ForwardRef as ReactComponent };